import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ExportColumn } from '../../../../models/export-column.model';
import { IPageInfo } from '../../../../base/interfaces/IPageInfo';
import { AttributeTypes } from '../../../../modules/shared/enums/attribute-types';
import { IAnalyticQuery } from '../../interfaces/IAnalyticsQuery';
import { AnalyticsColumn } from '../../models/analytics-column';
import { AnalyticsMenuItem } from '../../models/analytics-menu-item';
import { AnalyticsMenuItemChild } from '../../models/analytics-menu-item-child';
import { AnalyticsParameter } from '../../models/analytics-parameter';
import { AnalyticsService } from '../../services/analytics.service';
import { ParameterValue } from '../analytics-reference/parameter-value';
import { DownloadFile, ExportComponent } from '../../../../dialogs/export/export.component';
import { TranslateService } from '@ngx-translate/core';
import { ExportParameters } from '../../../../models/export-parameters.model';
import { AnalyticsExport, IExportOptions } from './analytics-export';
import { IDownloadResult, IExportOperationResult } from '../../../../base/interfaces/IDownloadResult';
import { FileUploadService } from '../../../../directives/file-drop/file-upload.service';

@Component({
  selector: 'app-analytics-filter',
  templateUrl: './analytics-filter.component.html',
  styleUrls: ['./analytics-filter.component.css']
})
export class AnalyticsFilterComponent implements OnInit, OnChanges {

  constructor(
    private analyticsService: AnalyticsService,
    private fileStoreService:FileUploadService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    this.form = new FormGroup({
      activeId: new FormControl(),
      sort: new FormControl(),
      sortDesc: new FormControl(false),
      attributes: new FormArray([])
    });    
   }
  
   public isInfoLoaded = false;
   public parameters: AnalyticsParameter[];
   public columns: AnalyticsColumn[];
   public form: FormGroup;
   public activeElement: AnalyticsMenuItem = null;
   public activeChild: AnalyticsMenuItemChild = null;
   public page:number = 1;
   public size:number;

  @Input() parent: string;
  @Input() pageInfo: IPageInfo;
  @Input() pageSizeOptions: number[];

  @Output() elementChange = new EventEmitter<AnalyticsMenuItemChild>();
  @Output() startExecute = new EventEmitter<boolean>();
  @Output() executed = new EventEmitter<IAnalyticQuery>();
  @Output() exported = new EventEmitter<IExportOptions>();
  ngOnInit() {
    this.form.get('activeId').valueChanges.subscribe(value => {
      if(value && this.activeElement && this.activeElement.children){
        const child:AnalyticsMenuItemChild =  this.activeElement.children.find(f => f.id === value);
        if(child){
          this.selectElement(child);
        }
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {    
    if(changes){
      if(changes.parent){
        this.analyticsService.getElement(this.parent).subscribe(elem => {
          this.activeElement = elem;
          if(elem && elem.children && elem.children.length > 0){
            this.selectElement(elem.children[0]);
          }
        })
      }
    }
  }
  getAttributeElement(index: number): FormControl {
    const array = <FormArray>this.form.get('attributes');
    return (<FormControl>array.at(index));
  }
  RefreshAttributes() {
    let currentAttributes: any[] = null;
    let attributes: any[] = null;
    if ( this.form.get('attributes').value) {
      currentAttributes = this.parameters;
      attributes = Object.assign({}, currentAttributes);
    }
    this.form.get('attributes').reset();
    const formAttributes: FormArray = new FormArray([]);
    if (this.parameters) {
      let i = 0;
      for (const attr of this.parameters) {
        const currentValue = currentAttributes.filter(f => f.id === attr.id);
        let attValue = null;
        if (currentValue && currentValue.length > 0) {
          attValue = currentValue[0].value;
        }
        const groupObject = {
          queryId: new FormControl(attr.id),
          id: new FormControl(attr.id),
          value: new FormControl(attValue || null),
          displayValue: new FormControl(null),
        };
        if (attr.type === 'reference') {
          if(attr.queryId){
            groupObject.queryId.setValue(attr.queryId);
          }
        }
        const formGroup = new FormGroup(groupObject);
        formAttributes.push(formGroup);
        i++;
      }
    }
    this.form.setControl('attributes', formAttributes);
  }
  selectElement(item: AnalyticsMenuItemChild){    
    if(item && this.activeChild !== item){
      this.activeChild = item;
      this.form.get('activeId').setValue(this.activeChild.id);
      this.analyticsService.getInfo(item.id).subscribe(info => {
        if(info){
          this.parameters = info.parameters;
          this.columns = info.columns;
          if(this.parameters){
            this.RefreshAttributes();
            this.form.controls['sort'].setValue(this.columns[0].id)
            this.isInfoLoaded = true;
          }
        }
      });
      this.elementChange.emit(item);
      setTimeout(() => {
        this.onExecute();        
      }, 500);
    }
  }
  onExecute(){    
    if(this.form.valid){
      this.executed.emit(this.getQuery());
    }
  }
  private getQuery(): IAnalyticQuery{
    const sort = this.form.get('sort').value;
    const sortDesc = this.form.get('sortDesc').value;
    const attributes:ParameterValue[] = <ParameterValue[]>this.form.get('attributes').value;
    const res = {};
    if(this.parameters){
      this.parameters.forEach(param => {
        let att = attributes.find(f => f.id === param.id);
        let val = att.value;
        if(att && att.value){
          switch(param.type){
            case AttributeTypes.Date:
              case AttributeTypes.DateTime:
                val = val.toISOString();
          }
        }
        res[param.id] = val;
      });
    }      
    if(this.pageSizeOptions && this.pageSizeOptions.length>0){
      this.size = this.pageSizeOptions[0];
    }      
    let size = this.size;      
    if(this.pageInfo && this.pageInfo.size){
      size = this.pageInfo.size;
    }
    const ret = <IAnalyticQuery>{
      skip: (this.page-1) * size,
      take: size,
      page: this.page,
      filters: res,
      size: size,
      sort: sort,
      sortDesc: sortDesc
    };
    return ret;
  }
  onRefresh(){
    this.onExecute();
  }
  public get isLastPage(){
    if(this.pageInfo && this.page){
      return this.page===this.pageInfo.pageCount;
    }
    else {
      return true;
    }
  }
  public get isFirstpae(){
    return this.page===1;
  }
  onNextPage(){
    if(this.pageInfo && this.pageInfo.page){
      this.page = this.pageInfo.page + 1
      this.onExecute();
    }
  }
  onPrevPage(){
    if(this.pageInfo && this.pageInfo.page && this.pageInfo.page>1){
      this.page = this.pageInfo.page - 1
      this.onExecute();
    }
  }
  toggleSortDirection() {
    const sortControl = this.form.get('sortDesc');
    const currentValue = <Boolean>sortControl.value;
    sortControl.setValue(!currentValue);
  }
  getColumns(): ExportColumn[] {
    const ret: ExportColumn[] = [];
    if(this.columns) {
      for(let a=0;a<this.columns.length;a++) {
        ret.push(new ExportColumn(this.columns[a].id,this.translateService.instant(this.columns[a].name)));
      }
    }
    return ret;
  }  
  onExport(){
    const query:IAnalyticQuery = this.getQuery();
    this.analyticsService.getExportTypes(this.activeChild.id).subscribe(types => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        title: 'dialogs.export',
        type: 'document',
        options: types,
        columns: this.getColumns()
      };
      const dialogRef = this.dialog.open(ExportComponent, dialogConfig);
      return dialogRef.afterClosed().subscribe((result: ExportParameters) => {        
        if (result) {
          const filter = <IAnalyticQuery>Object.assign({}, query);
          const name = this.translateService.instant(this.activeChild.name);
          const columns:AnalyticsColumn[] = [];
          if(result.columns) {
            result.columns.forEach(col => {
              if(col.enabled) {
                const column = Object.assign({},this.columns.find(f => f.id === col.key));
                column.name = col.name;
                columns.push(column);
              }
            });            
          }
          const exportOptions = <AnalyticsExport>{
            name: name,
            columns: columns
          };

          this.analyticsService.export(this.activeChild.id, result.type.code,
            0, 1000, query.filters, exportOptions, query.sort).subscribe((result:IExportOperationResult) => {
              if (result && result.payload && result.payload.export && result.payload.export.link) {
                DownloadFile(result.payload.export.link, name);
                this.fileStoreService.Delete(result.payload.export).subscribe();
              }
            }, (err) => {
            })  
        }
      });   
    });
  }  
}
